// extracted by mini-css-extract-plugin
export default {"form":"LoginPage_form__1f362"};